import { App as CapacitorApp } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { Preferences } from '@capacitor/preferences';
import axios from 'axios';
import API_BACKEND_URL from '@/API_URL/api_back_end.js';
import { isNativeApp } from '@/utils/platform';
import { getClientIdentity } from '@/utils/clientIdentity';

const CHECK_INTERVAL_MS = 60 * 60 * 1000;
const PREFS_KEY = 'appCompatibility.last';

let lastLiveCheckAt = 0;
let watchStarted = false;
let onBlock = () => {};
let onClear = () => {};

function platformFromIdentity(identity) {
    if (identity.kind === 'ios-app') {
        return 'ios';
    }
    if (identity.kind === 'android-app') {
        return 'android';
    }
    return '';
}

async function checkCompatibility() {
    if (!isNativeApp()) {
        return;
    }
    const now = Date.now();
    if (lastLiveCheckAt > 0 && now - lastLiveCheckAt < CHECK_INTERVAL_MS) {
        return;
    }

    const identity = getClientIdentity();
    const platform = platformFromIdentity(identity);
    if (!platform || !identity.version) {
        return;
    }

    try {
        const res = await axios.get(`${API_BACKEND_URL}app/compatibility`, {
            params: {
                platform,
                version: identity.version,
            },
        });
        lastLiveCheckAt = Date.now();
        const data = res.data && typeof res.data === 'object' ? res.data : {};
        try {
            await Preferences.set({
                key: PREFS_KEY,
                value: JSON.stringify({ at: lastLiveCheckAt, data }),
            });
        } catch (err) {
            // Cache ist optional
        }
        if (data.supported === false) {
            onBlock(data);
        } else {
            onClear();
        }
    } catch (err) {
        // Fail-open: kein Netz / Fehler darf nicht sperren.
    }
}

/**
 * @param {{ onBlock: Function, onClear: Function }} handlers
 */
export function startCompatibilityWatch(handlers = {}) {
    if (!isNativeApp() || watchStarted) {
        return;
    }
    watchStarted = true;
    onBlock = typeof handlers.onBlock === 'function' ? handlers.onBlock : () => {};
    onClear = typeof handlers.onClear === 'function' ? handlers.onClear : () => {};

    checkCompatibility();
    CapacitorApp.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
            checkCompatibility();
        }
    });
}

export async function openExternalUrl(url) {
    const href = String(url || '').trim();
    if (!href) {
        return;
    }
    await Browser.open({ url: href });
}
